import { EditcontrolledareaterminalComponent } from "src/app/features/parking/accesscontrol/controlledareas/edit/editcontrolledareaterminal/editcontrolledareaterminal.component";
import { LevelEditorComponent } from "../../leveleditor.component";
import { PointMapComponent } from "./PointMapComponent";
import { EditCarCounterConfiguration } from "../../../modals/editcarcounterconfiguration/editcarcounterconfiguration.component";

export class CarCounter extends PointMapComponent{
    public override ClassName: string = "Car Counter";
    public override ImageUrl: string = "/assets/leveleditor/carcounter.png"
    public override ImageScale = 0.04;
    public override CanDuplicate: boolean = false;
    public override IsGuidId: boolean = false;
    
    constructor(leveleditorcomponent: LevelEditorComponent, canvas: any, formItem: any, parentFormItem: any, forceClone: boolean = false) {
        super(leveleditorcomponent, canvas, formItem, parentFormItem, forceClone);
        this.AddFabricItem();
    }

    public override Clone(formitem: any){
        return new CarCounter(this.leveleditorcomponent, this.canvas, formitem, this.parentFormItem, true);
    }

    public override ShowModal(): void {
        this.leveleditorcomponent.modalService.addModal(EditCarCounterConfiguration, { Form: this.formItem })
        .subscribe((result) => {
        });
    }
}
